export default __webpack_public_path__ + "static/media/instruct_setup_forgot-password.1fdf0562.svg";